// internal deps
import { None, Option, Some } from "@swiggy-private/js-fp";
import { PaymentGroupDataDef, SplitPayData } from "@swiggy-private/payment-ui";

// interfaces
import { GetPaymentMethodsResponse } from "@payment-client/interfaces/PaymentApi";

// helpers
import { generatePaymentMethodId, isPreferredGroup } from "./PaymentHelper";
import { findSwiggyInstrumentFromSplitPayList } from "./SwiggyInstrumentsHelper";

export function getPreferredGroup(
    paymentGroups: GetPaymentMethodsResponse["paymentGroup"],
): Option<PaymentGroupDataDef> {
    return Some(paymentGroups.find(isPreferredGroup));
}

export const getFirstPreferredPaymentMethodId = (
    paymentResponse?: GetPaymentMethodsResponse | null,
): Option<string> => {
    if (paymentResponse == null) {
        return None;
    }
    const firstPpm = getPreferredGroup(paymentResponse.paymentGroup).andThen((group) => Some(group.paymentMethods[0]));

    return firstPpm.isNone() ? None : Some(generatePaymentMethodId(firstPpm.unwrap()));
};

const isSplitPayVisibleWithAddMoneyCta = (withSplitPay: boolean, splitPayMethod?: SplitPayData): boolean =>
    !!splitPayMethod?.showAddMoneyCta && withSplitPay;

export const shouldSelectFirstPreferredPaymentMethod = (
    isPaymentMethodSelectedForOnce: boolean,
    withSplitPay: boolean,
    splitPayList?: SplitPayData[],
): boolean => {
    const swiggyPayData = findSwiggyInstrumentFromSplitPayList(splitPayList);
    const splitPayVisibleWithAddMoneyCta = isSplitPayVisibleWithAddMoneyCta(withSplitPay, swiggyPayData);
    // Turbo/preferred "pay using" is now supported for accessibility users, so the preferred
    // method is auto-selected regardless of the accessibility header.
    //first preferred payment method is not selected when add money cta is shown in splitpay
    return !(isPaymentMethodSelectedForOnce || splitPayVisibleWithAddMoneyCta);
};
